import { Nullable } from '@/shared/types/app.types'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { store } from '@/store/store'

export interface ConfigurationOntology {
    id: number
    sampleType: Nullable<CommonSampleTypeResponse>
    topographicCode: Nullable<CommonTopographicCodeResponse>
    mostLikelyMorphologicCode: Nullable<CommonMostLikelyMorphologicCodeResponse>
    procedure: Nullable<CommonProcedureResponse>
}

export interface ConfigurationOntologiesState extends Partial<ConfigurationOntology> {
    laboratoryId: number
}
export const initialConfigurationOntologiesState =
    (): ConfigurationOntologiesState => ({
        sampleType: null,
        topographicCode: null,
        mostLikelyMorphologicCode: null,
        procedure: null,
        laboratoryId: store.getters.labId
    })
